<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      window.vue = this;
    },
  };
</script>

<style>
  #app {
    font-family: 'DM Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding: 0;
    margin: 0;
  }
  body {
    margin: 0;
    font-family: 'DM Sans', sans-serif;
  }

  .el-button {
    font-family: 'DM Sans', sans-serif;
  }

  /* 隐藏滚动条 */
  ::-webkit-scrollbar {
    width: 6px;
    height: 0;
  }

  /* 鼠标进入页面显示滚动条 */
  :hover::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  /*定义滑块
       内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #6b6b6b54;
  }

  .button {
    padding: 10px 22px !important;
    border: 2px solid #1f427c !important;
    border-radius: 0 !important;
    color: #1f427c !important;
    font-weight: 400 !important;
  }

  .button:hover {
    box-shadow: 0 0 0 0.1rem #1f427c !important;
  }

  .cobetter_primary_button {
    color: #ffffff !important;
    background-color: #1f427c !important;
  }

  .cobetter_border_button {
    color: #1f427c !important;
    background-color: #ffffff !important;
    border: 2px solid #1f427c !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue